import React from 'react';
import { useNavigate } from 'react-router-dom';

function Hero() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      const offsetTop = contactSection.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
  };

  const handleViewPortfolio = () => {
    const portfolioSection = document.querySelector('#portfolio');
    if (portfolioSection) {
      const offsetTop = portfolioSection.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center relative overflow-hidden pt-24 bg-white">
      {/* Background Elements */}
      <div className="hero-blob w-[600px] h-[600px] bg-green-400 rounded-full top-0 -right-64 animate-morph"></div>
      <div className="hero-blob w-[400px] h-[400px] bg-blue-400 rounded-full bottom-0 -left-32 animate-morph" style={{ animationDelay: '-4s' }}></div>
      
      {/* Floating Shapes */}
      <div className="floating-shape w-20 h-20 bg-green-200 top-32 left-20 animate-float" style={{ animationDelay: '0s' }}></div>
      <div className="floating-shape w-14 h-14 bg-blue-200 top-48 right-32 animate-float-reverse" style={{ animationDelay: '-2s' }}></div>
      <div className="floating-shape w-10 h-10 bg-green-300 bottom-32 left-1/4 animate-float" style={{ animationDelay: '-3s' }}></div>
      <div className="floating-shape w-16 h-16 bg-blue-300 bottom-48 right-1/4 animate-float-reverse" style={{ animationDelay: '-1s' }}></div>

      <div className="max-w-7xl mx-auto px-6 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-3 bg-green-50 border border-green-200 px-5 py-2.5 rounded-full text-sm font-medium text-green-700 animate-slide-up">
              <span className="w-2.5 h-2.5 bg-green-500 rounded-full animate-pulse"></span>
              <span>Available for new projects</span>
            </div>
            
            <h1 className="text-5xl md:text-7xl font-black leading-tight text-gray-900">
              <span className="block animate-slide-up" style={{ animationDelay: '0.1s' }}>We Build</span>
              <span className="block text-gradient animate-slide-up" style={{ animationDelay: '0.2s' }}>Digital</span>
              <span className="block animate-slide-up" style={{ animationDelay: '0.3s' }}>Experiences</span>
            </h1>
            
            <p className="text-xl text-gray-600 max-w-lg animate-slide-up leading-relaxed" style={{ animationDelay: '0.4s' }}>
              Transform your business with cutting-edge technology solutions. We craft innovative software that drives growth and delivers exceptional results.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 animate-slide-up" style={{ animationDelay: '0.5s' }}>
              <button 
                className="magnetic-btn bg-green-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-green-600 transition-all shadow-lg hover:shadow-green-500/30 flex items-center justify-center gap-2"
                onClick={handleGetStarted}
              >
                Get Started
                <i className="fas fa-arrow-right"></i>
              </button>
              <button 
                className="bg-gray-100 text-gray-800 px-8 py-4 rounded-full font-semibold hover:bg-gray-200 transition-all"
                onClick={handleViewPortfolio}
              >
                View Portfolio
              </button>
            </div>

            <div className="flex items-center gap-8 pt-4 animate-slide-up" style={{ animationDelay: '0.6s' }}>
              <div>
                <div className="text-3xl font-bold text-gray-900">100+</div>
                <div className="text-sm text-gray-600">Projects Completed</div>
              </div>
              <div className="h-12 w-px bg-gray-200"></div>
              <div>
                <div className="text-3xl font-bold text-gray-900">50+</div>
                <div className="text-sm text-gray-600">Happy Clients</div>
              </div>
              <div className="h-12 w-px bg-gray-200"></div>
              <div>
                <div className="text-3xl font-bold text-gray-900">15+</div>
                <div className="text-sm text-gray-600">Years Experience</div>
              </div>
            </div>
          </div>

          <div className="hero-image-container animate-float">
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&h=600&fit=crop" 
                alt="Digital Transformation" 
                className="w-full rounded-3xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl border border-gray-100 animate-bounce-soft">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center text-green-600">
                    <i className="fas fa-rocket"></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">98% Client Satisfaction</div>
                    <div className="text-sm text-gray-600">Industry Best</div>
                  </div>
                </div>
              </div>
              <div className="absolute -top-6 -right-6 bg-white p-6 rounded-2xl shadow-xl border border-gray-100 animate-bounce-soft" style={{ animationDelay: '1s' }}>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600">
                    <i className="fas fa-chart-line"></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">500% ROI</div>
                    <div className="text-sm text-gray-600">Average Increase</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Wave Animation */}
      <div className="wave-bg"></div>
    </section>
  );
}

export default Hero;